import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: 'ng-template[customInput]',
  standalone: false,
})
export class CustomInputDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
